import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, RESEARCH_ITEMS, imgUrl } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export const ResearchItem = ({ item, index }) => (
  <Link
    to={item.to}
    data-testid={`research-item-${index}`}
    className="group flex items-baseline gap-5 border-b border-atlantic/10 py-6 transition-colors first:border-t hover:bg-white"
  >
    <span className="font-serif text-sm text-gold">{String(index + 1).padStart(2, "0")}</span>
    <span className="flex-1">
      <span className="block font-serif text-lg leading-snug text-atlantic transition-colors group-hover:text-ocean sm:text-xl">
        {item.title}
      </span>
      <span className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">{item.type}</span>
    </span>
    <ArrowUpRight size={16} className="shrink-0 text-atlantic/40 transition-colors group-hover:text-gold" />
  </Link>
);

export default function Research() {
  return (
    <section id="research" data-testid="research-section" className="border-y border-atlantic/10 bg-sand-dark py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 lg:grid-cols-12 lg:gap-12 lg:px-8">
        <div className="lg:col-span-5">
          <SectionHeading
            chapter="04"
            kicker="Research and Policy"
            title="Analysis Built for Public Use"
            copy="Briefings, comparative studies, data explainers, institutional trackers and practical policy analysis — documented openly and written to be used."
          />
          <Reveal delay={0.15} className="relative mt-12 hidden lg:block">
            <div className="absolute -left-4 -bottom-4 h-full w-full border border-gold/50" aria-hidden="true" />
            <img
              src={imgUrl(IMAGES.map, 900)}
              alt="Map representing Africa–CARICOM institutional connections"
              loading="lazy"
              className="relative aspect-[4/3] w-full object-cover"
            />
          </Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.28em] text-slate-500">Featured Research</p>
          <div>
            {RESEARCH_ITEMS.map((item, i) => (
              <ResearchItem key={item.title} item={item} index={i} />
            ))}
          </div>
          <p className="mt-8 text-sm leading-relaxed text-slate-500">
            Trackers and dossiers are updated as cooperation commitments are announced, implemented or stall.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
